export const POST = 'POST';
export const TRIP = 'TRIP';
export const EVENT = 'EVENT';
export const CHECKIN = 'CHECKIN';
